"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetDropdownReporter = exports.DropdownContextComponent = exports.createPlacementWarning = exports.DropdownContextProvider = exports.DropdownContext = exports.defaultDropdownContext = void 0;

var _react = require("react");

var _memoize = _interopRequireDefault(require("react-utils/memoize"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var defaultDropdownContext = {
  shouldLogModalWarning: false
};
exports.defaultDropdownContext = defaultDropdownContext;
var DropdownContext = (0, _react.createContext)(defaultDropdownContext);
exports.DropdownContext = DropdownContext;
var Provider = DropdownContext.Provider;
exports.DropdownContextProvider = Provider;
var hasReportedDropdown = false;
var createPlacementWarning = (0, _memoize.default)(function (componentName) {
  return function () {
    if (hasReportedDropdown) return;

    if (window.newrelic) {
      window.newrelic.addPageAction("componentInDropdown", {
        componentName: componentName
      });
    }

    if (process.env.NODE_ENV !== 'production') {
      _devLogger.default.warn({
        message: "A `" + componentName + "` was rendered within a `UIDropdown`. Please refactor.",
        url: 'https://git.hubteam.com/HubSpot/UIComponents/issues/8857',
        key: componentName + "-in-dropdown"
      });
    }
  };
});
exports.createPlacementWarning = createPlacementWarning;

var DropdownContextComponent = function DropdownContextComponent(_ref) {
  var componentName = _ref.componentName;

  var _useContext = (0, _react.useContext)(DropdownContext),
      shouldLogModalWarning = _useContext.shouldLogModalWarning;

  var memoizedCreatePlacementWarning = createPlacementWarning(componentName);

  if (shouldLogModalWarning) {
    memoizedCreatePlacementWarning();
  }

  return null;
}; // For testing only


exports.DropdownContextComponent = DropdownContextComponent;

var resetDropdownReporter = function resetDropdownReporter() {
  hasReportedDropdown = false;
};

exports.resetDropdownReporter = resetDropdownReporter;